import React, { useCallback, useRef, useState, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { GridLayout } from "../../../../../common/GridLayout";
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    FilterPanel,
    Sorting,
    Paging,
    Editing,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    Selection,
    Lookup,
    Toolbar,
    Item,
    RequiredRule
} from "devextreme-react/data-grid";
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import { LoadPanel } from 'devextreme-react/load-panel';
import { DisableEnableControls, GetFormatedDateWithTime, onEditingStart } from '../../../../../common/Utils'

import { createStore } from 'devextreme-aspnet-data-nojquery';
import { alert, confirm } from 'devextreme/ui/dialog';

import "jspdf-autotable";
import "../../../../css/omstyle.css";
import notify from 'devextreme/ui/notify';
import { Button, DropDownButton, Popup, TextBox } from 'devextreme-react';

import axios from "axios";
import routes from "../../../../../assets/apiRoutes.json";
import PrimaryTab from "./detailTabs/PrimaryTab";
import AdditionalTab from "./detailTabs/AdditionalTab";
import UserDefinedTab from "./detailTabs/UserDefinedTab";
import UserDefinedTab1 from "./detailTabs/UserDefinedTab1";
import CommissionsTab from "./detailTabs/CommissionsTab";
import CommentTab from "./detailTabs/CommentTab";
import AlternateSKUTab from "./detailTabs/AlternateSKUTab";
import KitDetailTab from "./detailTabs/KitDetailTab";
import OtherChgsTab from "./detailTabs/OtherChgsTab";
import BackOrderTab from "./detailTabs/BackOrderTab";
import POTab from "./detailTabs/POTab";
import { ApplyMethod, isChargeAndHold, EMPTY_GUID, InventoryReview, RecordTypes, TransactionStage, TransactionStatus, TransactionTypes, YesNo, isChargeAndHoldShipment } from "../../../../../enum/Enum";
import { OMLocationOperations, DetailTypes } from "../../../../../enum/Enum";
import LocationHistoryList from "../../../../../im/common/lists/LocationHistoryList";
import FormField from "../../../../../dynamicFormBuilder/FormField";
import ChangeWarehousePopup from "./ChangeWarehousePopup";
import { MESSAGES } from "../../../../../common/Messages";
import PMProductionRequirementsModal from "./PMProductionRequirementsModal";
import CustomerItemHistoryPopup from "../common/CustomerItemHistoryPopup";
import SubstituteItemsPopup from "../common/SubstituteItemsPopup";
import SelectCostComponentsPopup from "../common/SelectCostComponentsPopup";
import TransactionDetailGridPopup from "../common/TransactionDetailGridPopup";
import OpenTransactionsForItemLotPopup from "../common/OpenTransactionsForItemLotPopup";
import ImItemStatusPopup from "../common/ImItemStatusPopup";
import ItemPricesPopup from "../common/ItemPricesPopup";
import ResetItemDiscountPopup from "../common/ResetItemDiscountPopup";
import SelectItemsPopup from "../common/SelectItemsPopup";
import CommonReport from "../../../../../reports/components/CommonReport";
import SortDetailRecordsPopup from "../common/SortDetailRecordsPopup";
import SerialNumberReceiptPopup from "../common/SerialNumberReceiptPopup";
import SerialNumberShipmentPopup from "../common/SerialNumberShipmentPopup";
import UpdateRequisitionDetailsPopup from "../common/UpdateRequisitionDetailsPopup";
import SerialNumberImportPopup from "../common/SerialNumberImportPopup";
import sanitizeHtml from "../../../../../common/sanitizeHtml";
import { ItemCodeSeparator } from "../../../../../const/constants";
import RenderSelectBoxCell, { useDetailPopup } from "../../../../../common/RenderCell";
import ItemDataEntryPopup from "../../../../../im/codes/itemDataEntry/common/ItemDataEntryPopup";
import LotDataEntryPopup from "../../../../../im/codes/lotDataEntry/common/LotDataEntryPopup";

const recordTypes = [{
    ID: "I",
    Text: "Inventory"
},
{
    ID: "N",
    Text: "Non Inventory"
}
]
let WarehouseId = "";

// "Record Range - IM Item Master" dialog. The dialog height and the height its panes are given come from
// one number so they cannot drift apart - a pane taller than its dialog is clipped by the wrapper's
// overflow:hidden. The subtraction is the dialog's own chrome: title bar, hint line, macro toolbar, tab
// header and footer.
const ITEM_RANGE_DIALOG_HEIGHT_VH = 90;
const ITEM_RANGE_DIALOG_CHROME_PX = 260;

const DetailsTab = (props) => {
    const accessToken = props.oidc?.user?.access_token;
    const headerRowId = props.formFields?.ROWID;

    const initialFormFields = {
        Rowid: EMPTY_GUID,
        RTransactionheader: props.formFields.ROWID,
        itemId: null,
        lotId: null,
        Quantityordered: null,
        Quantityshipped: null,
        UnitPrice: null,
        Amount: null,
        Linenumber: null,
        UnitOfMeasure: null,
        ReferenceNumber: null,
        Comment: null,
        UserDefinedComment: null,
        QuantityBackOrder: null,
        InventoryQuantity: null,
        ActualQuantity: null,
        OriginalQuantityOrdered: null,
        COGSAmount: null,
        OMDetailCode1: null,
        OMDetailCode2: null,
        OMDetailCode3: null,
        OMDetailCode4: null,
        OMDetailCode5: null,
        OMDetailCode6: null,
        OMDetailCode7: null,
        OMDetailCode8: null,
        OMDetailCode9: null,
        OMDetailCode10: null,
        OMDetailDate1: null,
        OMDetailDate2: null,
        OMDetailDate3: null,
        OMDetailDate4: null,
        OMDetailDate5: null,
        OMDetailDate6: null,
        OMDetailDate7: null,
        OMDetailDate8: null,
        OMDetailDate9: null,
        OMDetailDate10: null,
        OMDetailQuantity1: null,
        OMDetailQuantity2: null,
        OMDetailQuantity3: null,
        OMDetailQuantity4: null,
        OMDetailQuantity5: null,
        OMDetailQuantity6: null,
        OMDetailQuantity7: null,
        OMDetailQuantity8: null,
        OMDetailQuantity9: null,
        OMDetailQuantity10: null,
        OMDetailReference1: null,
        OMDetailReference2: null,
        OMDetailReference3: null,
        OMDetailReference4: null,
        OMDetailReference5: null,
        OMDetailReference6: null,
        OMDetailReference7: null,
        OMDetailReference8: null,
        OMDetailReference9: null,
        OMDetailReference10: null,
        TransactionNumber: null,
        HeaderShippingDate: null,
        CustomerID: null,
        CustomerName: null,
        DiscountedPrice: null,
        LotAvailable: null,
        LotNetAvailable: null,
        LotSupply: null,
        LotLeftToSell: null,
        LotCode: null,
        LotDesc1: null,
        LotDesc2: null,
        Code1Lot: null,
        Code2Lot: null,
        Code3Lot: null,
        Code4Lot: null,
        Code5Lot: null,
        Code6Lot: null,
        Code7Lot: null,
        Code8Lot: null,
        Code9Lot: null,
        Code10Lot: null,
        Date1Lot: null,
        Date2Lot: null,
        Date3Lot: null,
        Date4Lot: null,
        Date5Lot: null,
        Date6Lot: null,
        Date7Lot: null,
        Date8Lot: null,
        Date9Lot: null,
        Date10Lot: null,
        Quantity1Lot: null,
        Quantity2Lot: null,
        Quantity3Lot: null,
        Quantity4Lot: null,
        Quantity5Lot: null,
        Quantity6Lot: null,
        Quantity7Lot: null,
        Quantity8Lot: null,
        Quantity9Lot: null,
        Quantity10Lot: null,
        Reference1Lot: null,
        Reference2Lot: null,
        Reference3Lot: null,
        Reference4Lot: null,
        Reference5Lot: null,
        Reference6Lot: null,
        Reference7Lot: null,
        Reference8Lot: null,
        Reference9Lot: null,
        Reference10Lot: null,
        ItemCode: null,
        ItemDesc1: null,
        ItemDesc2: null,
        Classcode: null,
        Subclasscode: null,
        WarehouseID: null,
        WarehouseName: null,
        LotPctOversoldCurrently: null,
        OrderStatus: null,
        DetailType: null,
        Status: null,
        ItemDescription1: null,
        ItemDescription2: null,
        InventoryUnitUOM: null,
        ItemType: null,
        ItemStatus: null,
        BomExplosionFlag: null,
        OmKitFlag: null,
        StandardCost: null,
        ItemPayGroup: null,
        RLocation: null,
        RLocationPrimaryReserve: null,
        PmKitFlag: null,
        ItemAvailable: null,
        ItemNetAvailable: null,
        ItemUpcCode: null,
        DateAvailable: null,
        DateExpiration: null,
        PriceSource: null,
        LotDescription1: null,
        LotDescription2: null,
        LotUOM: null,
        LotStatus: null,
        LotAlternateSKU: null,
        IdentityId: null,
        ItemReference1: null,
        ItemReference2: null,
        ItemReference3: null,
        ItemReference4: null,
        ItemReference5: null,
        ItemReference6: null,
        ItemReference7: null,
        ItemReference8: null,
        ItemReference9: null,
        ItemReference10: null,
        ItemReference11: null,
        ItemReference12: null,
        ItemReference13: null,
        ItemReference14: null,
        ItemReference15: null,
        ItemReference16: null,
        ItemReference17: null,
        ItemReference18: null,
        ItemReference19: null,
        ItemReference20: null,
        WebAccessibility: null,
        ApplyMethod: null,
        AllowUnSpecified:null,
        ChangePrice: null,
        BackReviewBackorderFlag: null,
        BackReviewBackorderReason: null,
        BackConfirmBackorderFlag: null,
        BackConfirmBackorderReason: null,
        PSDetailRetailPrice: null,
        PSDetailAlternateSKU: null,
        PSDetailComment: null,
        LotCostBasisMethodFlag: null,
        LotStandardCost: null,
        OriginalQuantity: null,
        Reviewbackorderflag: null,
        Reviewbackorderreason: null,
        Confirmbackorderflag: null,
        Confirmbackorderreason: null,
        UnitOfMeasure: null,
        RProductcategory: null,
        Taxableflag: null,
        Pickstatus: null,
        Artradediscountflag: null,
        Artermsdiscountflag: null,
        Shippingdate: null,
        RFees: null,
        Feesadded: null,
        Feesincluded: null,
        Originalquantityordered: null,
        Discountpercent: null,
        Referencenumber: null,
        Alternatedescription: null,
        Userdefinedcode1: null,
        Userdefinedcode2: null,
        Userdefinedcode3: null,
        Userdefinedcode4: null,
        Userdefinedcode5: null,
        Userdefinedcode6: null,
        Userdefinedcode7: null,
        Userdefinedcode8: null,
        Userdefinedcode9: null,
        Userdefinedcode10: null,
        Userdefineddate1: null,
        Userdefineddate2: null,
        Userdefineddate3: null,
        Userdefineddate4: null,
        Userdefineddate5: null,
        Userdefineddate6: null,
        Userdefineddate7: null,
        Userdefineddate8: null,
        Userdefineddate9: null,
        Userdefineddate10: null,
        Userdefinedquantity1: null,
        Userdefinedquantity2: null,
        Userdefinedquantity3: null,
        Userdefinedquantity4: null,
        Userdefinedquantity5: null,
        Userdefinedquantity6: null,
        Userdefinedquantity7: null,
        Userdefinedquantity8: null,
        Userdefinedquantity9: null,
        Userdefinedquantity10: null,
        Userdefinedreference1: null,
        Userdefinedreference2: null,
        Userdefinedreference3: null,
        Userdefinedreference4: null,
        Userdefinedreference5: null,
        Userdefinedreference6: null,
        Userdefinedreference7: null,
        Userdefinedreference8: null,
        Userdefinedreference9: null,
        Userdefinedreference10: null,
        UserDefinedComment: null,
        Comment: null,
        Itemsupccode: null,
        CustomerItem: null,
        Lotupccode: null,
        Inventoryreview:null,
        Freightrateperitem: null,
        FreightRatePerItemChange: null,
    }
    const [formFields, setformFields] = useState(initialFormFields);
    const buttonDropDownOptions = { width: 430, height: 400 };
    const [dropDownItems, setDropDownItems] = useState([]);
    const [showLocationHistory, setShowLocationHistory] = useState({ visible: false, RItem: null, RLot: null });
    const [pmRequirementsModal, setPmRequirementsModal] = useState({ visible: false, formData: null });
    const [showChangeWarehouse, setShowChangeWarehouse] = useState({
        visible: false,
        currentWarehouseId: null,
        currentWarehouseName: null,
    });
    const [showCustomerItemHistory, setShowCustomerItemHistory] = useState({visible: false,RItem:null,HeaderRowId:null,CustomerId:null});
    const [showSubstituteItems, setShowSubstituteItems] = useState({ visible: false, data: [] });
    const [showCostComponents, setShowCostComponents] = useState({visible: false,headerRowId:null,detailRowId:null});
    const [showTransactionDetailGrid, setShowTransactionDetailGrid] = useState({
        visible: false,
        transactionHeaderId: null,
        title: "OM Transaction Detail Grid",
    });
    const [showImItemStatus, setShowImItemStatus] = useState({
        visible: false,
        rItem: null,
        rLot: null,
        itemCode: null,
        warehouseName: null,
        lotCode: null,
        sublotCode: null,
        unitOfMeasure: null,
    });
    const [showItemPrices, setShowItemPrices] = useState({
        visible: false,
        rItem: null,
    });
    // Hosts the popup a cell's lookup button opens (outside the grid, so closing the editor keeps it).
    const { openDetailPopup, detailPopup } = useDetailPopup();
    const [showOpenTransactionForItemLot, setShowOpenTransactionForItemLot] = useState({
        visible: false,
        itemId: null,
        lotId: null,
        detailRowId: null,
        title: "Open Transactions for Item/Lot",
    });
    const dataGrid = useRef(null);
    // Persisted column layout for the OM detail grid (custom StateStoring + GridLayoutManager, mirrors List.js).
    const gridKey = "7F3C1A64-2E9B-4D51-A8C7-1B6E0F9D42A5";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout); }, [currentLayout]);
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const importDetailsFileInputRef = useRef(null);
    const importDetailsPendingFileRef = useRef(null);
    const [importDetailsPreview, setImportDetailsPreview] = useState({
        visible: false,
        html: "",
        importAllowed: false,
        sourceLabel: "",
    });
    const [showSerialImport, setShowSerialImport] = useState({
        visible: false,
        headerRowId: null,
        layoutRowId: null,
        layoutName: null,
    });
    const [showResetItemDiscount, setShowResetItemDiscount] = useState({
        visible: false,
        headerRowId: null,
        defaultDetailDiscount: null,
    });
    const [showSelectItems, setShowSelectItems] = useState({
        visible: false,
        headerRowId: null,
        warehouseId: null,
        warehouseName: null,
    });
    // Range/macro dialog shown before the item picker, mirroring the legacy "Record Range - IM Item Master"
    // step: the criteria set here are appended to the item query's WHERE clause in SQL, which is what makes a
    // site with tens of thousands of items usable. `pending` carries the Select Items arguments across the two
    // dialogs so the picker opens with the same order/pricing context either way.
    const [showItemRange, setShowItemRange] = useState({ visible: false, pending: null });
    const itemRangeRef = useRef(null);
    const [showSortDetailRecords, setShowSortDetailRecords] = useState(false);
    const [showSerialNumberReceipt, setShowSerialNumberReceipt] = useState({
        visible: false,
        detailRowId: null,
    });
    const [showSerialNumberShipment, setShowSerialNumberShipment] = useState({
        visible: false,
        detailRowId: null,
    });
    const [showRequisitionDetails, setShowRequisitionDetails] = useState({
        visible: false,
        headerRowId: null,
        detailRowId: null,
        title: "Requisition Detail Viewer",
    });
    const detailSortRef = useRef(null);
    const dataSource = useMemo(
        () =>
            createStore({
                key: "Rowid",
                loadUrl: `${window._env_.REACT_APP_APIS}/${routes.OM.GetTransactionDetails}`,
                insertUrl: `${window._env_.REACT_APP_APIS}/${routes.OM.InsertTransactionDetailGrid}`,
                updateUrl: `${window._env_.REACT_APP_APIS}/${routes.OM.UpdateTransactionDetails}`,
                deleteUrl: `${window._env_.REACT_APP_APIS}/${routes.OM.DeleteTransactionDetails}`,
                loadParams: {
                    RTransactionheader: headerRowId,
                    SortBy: () => detailSortRef.current?.orderBy ?? "",
                    SortDescending: () => detailSortRef.current?.descending ?? false,
                },
                onBeforeSend(method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`,
                        Key: headerRowId,
                    };
                },
            }),
        [headerRowId, accessToken]
    );
    const warehousesStore = createStore({

        loadUrl: `${window._env_.REACT_APP_APIS}/${routes.OM.GetWareHouses}`,
        key: 'rowid',
        loadParams:
        {
            masterRowId: function () {

                return props.identityMasterRowId;
            },
            take: 100
        },
        onBeforeSend: function (method, ajaxOptions) {
            ajaxOptions.headers = {
                Authorization: `Bearer ${accessToken}`
            };
        }
    });
    const [selectedItemKeys, setSelectedItemKeys] = useState([]);
    const [isShiped, setIsShiped] = useState(false);
const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, [setLoadPanelVisible]);
    const position = { of: '#accordion-containe2' };

    const handleCellValueChanged = (data) => {

        setSelectedItemKeys(data.selectedRowKeys);
        setformFields(data.selectedRowsData[0]??initialFormFields);
    }

    useEffect(() => {
        if (props.stage === "A" || props.stage === "S" || props.stage === "C")
            setIsShiped(true);
        else
            setIsShiped(false);
    }, [props?.stage])

    useEffect(() => {
        if (!props.detailGridRefreshNonce) return;
        const grid = dataGrid.current?.instance();
        if (grid) grid.refresh();
    }, [props.detailGridRefreshNonce]);

    useEffect(() => {
        setSelectedItemKeys([]);
        setformFields({ ...initialFormFields });
        detailSortRef.current = null;
        const runRefresh = () => {
            const grid = dataGrid.current?.instance();
            if (grid) {
                try {
                    grid.deselectAll();
                    grid.refresh();
                } catch {
                    /* grid may be remounting */
                }
            }
        };
        const t = window.requestAnimationFrame(runRefresh);
        return () => window.cancelAnimationFrame(t);
    }, [props.formFields?.ROWID]);

    const closeItemRange = useCallback(() => {
        setShowItemRange({ visible: false, pending: null });
    }, []);

    /**
     * Hands the range dialog's criteria to the item picker.
     *
     * `applyRange` false is the "Show All Items" path — the picker then calls the unfiltered endpoint, which is
     * how it behaved before this step existed. With a range, the criteria travel to the API and are applied in
     * SQL, so the grid never has to page through the whole item master.
     */
    const openSelectItemsFromRange = useCallback(async (applyRange) => {
        const pending = showItemRange.pending;
        if (!pending) {
            closeItemRange();
            return;
        }

        let rangeFilters = [];
        let macroName = "";

        if (applyRange && itemRangeRef.current) {
            try {
                rangeFilters = (await itemRangeRef.current.getRangeFilters()) || [];
                macroName = itemRangeRef.current.getReport()?.macroName || "";
            } catch (error) {
                notify({ message: MESSAGES.FETCH_ERROR, width: 300 }, "error", 5000);
                return;
            }
        }

        setShowItemRange({ visible: false, pending: null });
        setShowSelectItems({ ...pending, rangeFilters, macroName });
    }, [showItemRange.pending, closeItemRange]);

    const deleteRecords = useCallback(() => {

        let result = confirm("<i>Are your sure you want to delete selected records?</i>", "Delete");
        result.then((dialogResult) => {
            if (dialogResult) {
                dataGrid.current.instance().beginCustomLoading("Deleting");
                axios.post
                    (
                        `${window._env_.REACT_APP_APIS}/${routes.OM.DeleteTransactionDetails}`,
                        selectedItemKeys,
                        {
                            headers: {
                                "Content-Type": "application/json",
                                access_token: accessToken,
                            },
                        }
                    )
                    .then((res) => {
                        dataGrid.current.instance().endCustomLoading();
                        dataGrid.current.instance().refresh();
                        props.changeTotals(props.formFields.ROWID, props.formFields.SHIPPINGDATE);
                    })
                    .catch((err) => {
                        dataGrid.current.instance().endCustomLoading();
                        alert(err, "Error");
                    });

            }
        });

    }, [selectedItemKeys]);
        const updateRecords = useCallback(() => {
            setLoadPanelVisible(true);
                        let fields = formFields;
                        /* Fill the date fields with formatted date */
                        fields.DateAvailable= GetFormatedDateWithTime(formFields.DateAvailable);
                        fields.DateExpiration= GetFormatedDateWithTime(formFields.DateExpiration);
                        fields.Shippingdate= GetFormatedDateWithTime(formFields.Shippingdate);
                        fields.Userdefineddate1= GetFormatedDateWithTime(formFields.Userdefineddate1);
                        fields.Userdefineddate2= GetFormatedDateWithTime(formFields.Userdefineddate2);
                        fields.Userdefineddate3= GetFormatedDateWithTime(formFields.Userdefineddate3);
                        fields.Userdefineddate4= GetFormatedDateWithTime(formFields.Userdefineddate4);
                        fields.Userdefineddate5= GetFormatedDateWithTime(formFields.Userdefineddate5);
                        fields.Userdefineddate6= GetFormatedDateWithTime(formFields.Userdefineddate6);
                        fields.Userdefineddate7= GetFormatedDateWithTime(formFields.Userdefineddate7);
                        fields.Userdefineddate8= GetFormatedDateWithTime(formFields.Userdefineddate8);
                        fields.Userdefineddate9= GetFormatedDateWithTime(formFields.Userdefineddate9);
                        fields.Userdefineddate10=GetFormatedDateWithTime(formFields.Userdefineddate10);
                axios.post
                    (
                        `${window._env_.REACT_APP_APIS}/om/SaleOrder/UpdateTransactionDetailsByRowId`,
                        fields,
                        {
                            headers: {
                                "Content-Type": "application/json",
                                access_token: accessToken,
                            },
                        }
                    )
                    .then((res) => {
                        dataGrid.current.instance().refresh();
                        notify(
                            {
                                message: "Transaction Details Updated",
                                width: 200,
                            },
                            'success',
                            3000,
                        );
                    })
                    .catch((err) => {
                        alert(err, "Error");
                    }).finally(()=> setLoadPanelVisible(false));

    }, [formFields]);


    /* The lookup glyph beside the Item / Lot pickers (legacy IM Lot Code Entry → Class / Sub Class):
       opens the row's item or lot in the IM data-entry form, the same popup wrappers the item and
       lot search results use. */
    const itemDetail = useCallback((rowData) => ({
        component: ItemDataEntryPopup,
        componentProps: { title: MESSAGES.ITEM_DATA_ENTRY_TITLE },
        hint: MESSAGES.ITEM_DATA_ENTRY_TITLE,
        disabled: !rowData?.itemId,
        onOpen: openDetailPopup,
        value: { id: rowData?.itemId },
    }), [openDetailPopup]);
    const lotDetail = useCallback((rowData) => ({
        component: LotDataEntryPopup,
        componentProps: { title: MESSAGES.LOT_DATA_ENTRY_TITLE },
        hint: MESSAGES.LOT_DATA_ENTRY_TITLE,
        disabled: !rowData?.lotId,
        onOpen: openDetailPopup,
        value: { id: rowData?.lotId },
    }), [openDetailPopup]);
    /* Keeps the item / lot pickers showing the code already on the row: the picked key is often not
       on the first loaded page, so answer byKey locally instead of letting the cell go blank. */
    const resolveRowCode = (rowValueId, rowCode) => (itemKey) =>
        itemKey && itemKey === rowValueId && rowCode != null && rowCode !== ""
            ? { rowid: rowValueId, code: rowCode }
            : null;
    const renderItemCell = (cellElement) =>
        RenderSelectBoxCell({
            // Items are scoped to the row's warehouse — no warehouse yet means nothing to pick from.
            loadUrl: cellElement.row.data?.WarehouseID
                ? `${window._env_.REACT_APP_APIS}/${routes.OM.GetItems}`
                : null,
            key: "rowid",
            loadParams: {
                RWarehouse: function () { return cellElement.row.data?.WarehouseID; },
                RPriceScheduleHeader: function () { return props.formFields.RPriceScheduleHeader; },
                ApplyMethod: function () { return formFields.ApplyMethod; },
                AllowUnSpecified: function () { return formFields.AllowUnSpecified; },
            },
            valueExpr: "rowid",
            displayExpr: "code",
            accessToken: accessToken,
            defaultValue: cellElement.row.data?.itemId,
            resolveKeyLocally: resolveRowCode(cellElement.row.data?.itemId, cellElement.row.data?.ItemCode),
            // Clearing the picker must reach the cell as an empty value so RequiredRule still fires.
            onValueChangeCallback: (value, text, additionalData) => {
                cellElement.setValue(value ? { value, text, additionalData } : null);
            },
            detail: itemDetail(cellElement.row.data),
        });
    const renderWarehouseCell = (cellElement) =>
        RenderSelectBoxCell({
            loadUrl: `${window._env_.REACT_APP_APIS}/${routes.OM.GetWareHouses}`,
            key: "rowid",
            loadParams: { customerIdentity: "" },
            valueExpr: "rowid",
            displayExpr: "code",
            accessToken: accessToken,
            defaultValue: cellElement.row.data?.WarehouseID,
            // Clearing the picker must reach the cell as an empty value so RequiredRule still fires.
            onValueChangeCallback: (value, text) => {
                cellElement.setValue(value ? { value, text } : null);
            },
        });
    const renderLotCell = (cellElement) =>
        RenderSelectBoxCell({
            loadUrl: `${window._env_.REACT_APP_APIS}/${routes.OM.GetLots}`,
            key: "rowid",
            loadParams: {
                masterRowId: function () { return cellElement.row.data?.itemId; },
            },
            valueExpr: "rowid",
            displayExpr: "code",
            accessToken: accessToken,
            defaultValue: cellElement.row.data?.lotId,
            resolveKeyLocally: resolveRowCode(cellElement.row.data?.lotId, cellElement.row.data?.LotCode),
            onValueChangeCallback: (value, text) => {
                cellElement.setValue(value ? { value, text } : null);
            },
            detail: lotDetail(cellElement.row.data),
        });
    function setStateValue(rowData, newValue) {

        rowData.WarehouseID = newValue?.value ?? null;
        rowData.WarehouseName = newValue?.text ?? null;
        WarehouseId = newValue?.value ?? "";
    }
    // Shared row-stamping for all three pick paths (Item cell, Alternate SKU and Customer SKU
    // pickers): keeps the item key, code and alternate SKU in sync on the row. Callers stamp any extra
    // fields (desc/warehouse) they carry.
    function stampItemOntoRow(rowData, item) {
        rowData.itemId = item.rowId;
        rowData.ItemCode = item.itemCode;
        rowData.Itemsupccode = item.itemSupcCode;
        // OMM0000.GetCustomerSKU re-derives CUSTOMERITEM for the new item and clears it when the item has
        // no cross-reference, so a changed item must never keep the SKU stamped for the previous one. The
        // cross-ref picker below re-stamps its own value right after calling this. Empty string, not null:
        // UpdateTransactionDetails reads null as "this field was not part of the partial update".
        rowData.CustomerItem = "";
    }
    /* OMD0014.btnOKClick: picking a customer cross-reference resolves the customer's SKU to our item
       (and its lot, when the cross-reference names one) and stamps CUSTOMERITEM onto the detail line.
       The row's warehouse is left alone: btnOKClick never touches P_WAREHOUSE, so the line keeps the
       warehouse it was created with (the transaction profile's default, or the customer on a Charge and
       Hold shipment). The lot comes from the entry that was picked, not from the cross-reference row. */
    function stampCustomerCrossRefOntoRow(rowData, xref) {
        stampItemOntoRow(rowData, {
            rowId: xref.rItem ?? null,
            itemCode: xref.itemCode ?? null,
            itemSupcCode: xref.itemSupcCode ?? "",
        });
        rowData.ItemDesc1 = xref.description1 ?? null;
        rowData.CustomerItem = xref.customerItem ?? "";
        // lotRowId, not the cross-reference's own rLot: the list carries one entry per lot of the item
        // (OMD0014's ALL-lots query), so the lot to stamp is the one the picked entry stands for. Still
        // only when there is one - an item with no lots leaves the line's Lot cell alone.
        if (xref.lotRowId) {
            rowData.lotId = xref.lotRowId;
            rowData.LotCode = xref.lotCode ?? null;
        }
    }
    /* Undoing a pick: the cell stamped the item, its description, its alternate SKU and the lot the
       picked entry stood for, so clearing the SKU has to take all of them back with it
       rather than leave the row carrying an item the user just cleared. Empty string, not null, for
       the text fields: UpdateTransactionDetails reads null as "this field was not part of the partial
       update". */
    function clearCustomerCrossRefFromRow(rowData) {
        rowData.CustomerItem = "";
        rowData.itemId = null;
        rowData.ItemCode = "";
        rowData.Itemsupccode = "";
        rowData.ItemDesc1 = "";
        rowData.lotId = null;
        rowData.LotCode = "";
    }
    /* IMCUSTOMERCROSSREFERENCE rows vary by item, lot and warehouse, so one customer SKU commonly owns
       several of them - and the picker lists every cross-reference in the company, not just the order
       customer's, which repeats a SKU string across unrelated items. Rendering the SKU on its own would
       show those as identical entries that resolve to different items and lots. The legacy OMD0014 grid
       told them apart with its ITEMCODE and LOT columns; the dropdown carries the same two fields in
       the entry text. */
    function formatCustomerCrossRef(xref) {
        if (!xref) return "";
        const sku = xref.customerItem ?? "";
        const resolvesTo = [xref.itemCode, xref.lotCode].filter(Boolean).join(" / ");
        return resolvesTo ? `${sku} - ${resolvesTo}` : sku;
    }
    function setItemValue(rowData, newValue) {

        // Cross-populate the Alternate SKU cell with the picked item's SUPC code.
        stampItemOntoRow(rowData, {
            rowId: newValue?.value ?? null,
            itemCode: newValue?.text ?? null,
            itemSupcCode: newValue?.additionalData?.itemSupcCode ?? "",
        });
    }
    function setLotValue(rowData, newValue) {

        rowData.lotId = newValue?.value ?? null;
        rowData.LotCode = newValue?.text ?? null;
    }
    const handleValueChange = (e) => {
        props.changeTotals(props.formFields.ROWID, props.formFields.SHIPPINGDATE);
    };
    /* OMM0000.qryOMTransactionDetailAfterInsert: the warehouse a brand-new detail line starts with —
       the transaction profile's default warehouse (R_DEFAULTWH), or the order's customer when this is
       a Charge & Hold shipment. Shared by the grid's new row and the Select Items popup so both
       creation paths agree; { id: null } when the profile carries no default. */
    const defaultDetailWarehouse = useMemo(() => {
        if (isChargeAndHoldShipment(props.formFields?.CHARGEANDHOLDTYPE)) {
            return {
                id: props.formFields?.R_CUSTOMER ?? null,
                name: props.formFields?.CUSTOMERIDENTITYID ?? null,
            };
        }
        return {
            id: props.formFields?.ProfileDefaultWarehouse ?? null,
            name: props.formFields?.ProfileDefaultWarehouseName ?? null,
        };
    }, [
        props.formFields?.CHARGEANDHOLDTYPE,
        props.formFields?.R_CUSTOMER,
        props.formFields?.CUSTOMERIDENTITYID,
        props.formFields?.ProfileDefaultWarehouse,
        props.formFields?.ProfileDefaultWarehouseName,
    ]);
    /* OMM0000.qryOMTransactionDetailAfterInsert: default the new detail line from the transaction
       profile — Type is always Inventory, Warehouse comes from defaultDetailWarehouse above. */
    const onInitNewRow = useCallback((e) => {
        e.data.DetailType = DetailTypes.Item;
        if (defaultDetailWarehouse.id) {
            e.data.WarehouseID = defaultDetailWarehouse.id;
            e.data.WarehouseName = defaultDetailWarehouse.name;
            // Keep the shared picker state in sync so editing the Item cell scopes to this warehouse.
            WarehouseId = defaultDetailWarehouse.id;
        }
    }, [defaultDetailWarehouse]);
    /* The new row was abandoned — drop the warehouse we stamped above so the Item picker isn't left
       scoped to it, and fall back to the selected line's warehouse. */
    const onEditCanceled = useCallback(() => {
        WarehouseId = formFields.WarehouseID ?? "";
    }, [formFields.WarehouseID]);
    const setActionDropDownItems = useCallback(() => {
        const items = Object.entries(OMLocationOperations)
            .filter(([id]) => {
                if (id === "ImportDetails") {
                    return (
                        props.formFields?.ROWID &&
                        props.formFields.ROWID !== "00000000-0000-0000-0000-000000000000"
                    );
                }
                if (id === "TransactionDetailGrid") {
                    return (
                        selectedItemKeys.length > 0 &&
                        props.formFields?.STATUS !== TransactionStatus.Committed
                    );
                }
                if (id === "CommitCommission") {
                    const showCommitCommission =
                        (props.formFields.COMMISSIONTYPE === "D" || props.formFields.COMMISSIONTYPE === "M") &&
                        (props.formFields.STAGE === TransactionStage.Pending ||
                            props.formFields.STAGE === TransactionStage.Assigned ||
                            props.formFields.STAGE === TransactionStage.Picked ||
                            props.formFields.STAGE === TransactionStage.Completed);
                    if (!showCommitCommission) return false;
                }
                if (id === "ResetDefaultFreightRatePerItem") {
                    return props.formFields?.RECORDTYPE === "R";
                }
                /* OMD0000 opShowSerialNumberReceiptEntryForm.Visible: Credit transactions only
                   (TRANSACTIONTYPE 'C'), never on charge-and-hold orders — mutually exclusive
                   with the Shipment form option below. */
                if (id === "ShowSerialNumberReceiptEntryForm") {
                    return (
                        props.formFields?.TRANSACTIONTYPE === "C" &&
                        !isChargeAndHold(props.formFields?.CHARGEANDHOLDTYPE)
                    );
                }
                /* OMD0000 opShowSerialNumberShipmentForm.Visible: Invoice transactions only
                   (TRANSACTIONTYPE 'I'), never on charge-and-hold orders. */
                if (id === "ShowSerialNumberShipmentForm") {
                    return (
                        props.formFields?.TRANSACTIONTYPE === TransactionTypes.Invoice &&
                        !isChargeAndHold(props.formFields?.CHARGEANDHOLDTYPE)
                    );
                }
                /* OMD0000 opUpdateSerialNumbers.Visible: Credit ('C') or Invoice ('I') transactions,
                   never on charge-and-hold orders. */
                if (id === "UpdateSerialNumbers") {
                    return (
                        (props.formFields?.TRANSACTIONTYPE === TransactionTypes.Credit ||
                            props.formFields?.TRANSACTIONTYPE === TransactionTypes.Invoice) &&
                        !isChargeAndHold(props.formFields?.CHARGEANDHOLDTYPE)
                    );
                }
                /* OMM0000: IM item / quantity features apply to inventory detail (DETAILTYPE 'I'), not non-inventory ('N'). */
                if (id === "DisplayItemStatus" && formFields.DetailType !== "I") {
                    return false;
                }
                if (id === "DisplayItemPrices" && formFields.DetailType !== "I") {
                    return false;
                }
                /* OMD0000.opSubstituteItems: only for inventory detail lines (DETAILTYPE 'I'). */
                if (id === "SubstituteItems" && formFields.DetailType !== DetailTypes.Item) {
                    return false;
                }
                return true;
            })
            .map(([id, config]) => {
                const allowWithoutDetailSelection = config.allowWithoutDetailSelection === true;
                const base = {
                    id,
                    name: config.name,
                    disabled:
                        config.isHeader ||
                        (!allowWithoutDetailSelection && selectedItemKeys.length === 0),
                };
                if (config.isHeader) return base;
                if (id === "DisplayLocationHistory" && !formFields.ItemCode) {
                    return { ...base, disabled: true };
                }
                /* OMM0000: P_ITEM required — same pattern as qryOMTransactionDetailUpdatePrice (DETAILTYPE 'I' and item set). */
                if (
                    id === "DisplayItemStatus" &&
                    (!formFields.ItemCode || !formFields.itemId)
                ) {
                    return { ...base, disabled: true };
                }
                if (
                    id === "DisplayItemPrices" &&
                    (!formFields.ItemCode || !formFields.itemId)
                ) {
                    return { ...base, disabled: true };
                }
                if (
                    id === "SubstituteItems" &&
                    (formFields.DetailType !== DetailTypes.Item || !formFields.itemId)
                ) {
                    return { ...base, disabled: true };
                }
                if (
                    id === "OpenTransactionForItemLot" &&
                    (props.formFields.ROWID === "00000000-0000-0000-0000-000000000000" || !formFields.itemId)
                ) {
                    return { ...base, disabled: true };
                }
                if (
                    id === "ShowSerialNumberReceiptEntryForm" &&
                    (formFields.DetailType !== "I" ||
                        !formFields.itemId ||
                        !formFields.Rowid ||
                        formFields.Rowid === "00000000-0000-0000-0000-000000000000")
                ) {
                    return { ...base, disabled: true };
                }
                if (
                    id === "ShowSerialNumberShipmentForm" &&
                    (formFields.DetailType !== "I" ||
                        !formFields.itemId ||
                        !formFields.Rowid ||
                        formFields.Rowid === "00000000-0000-0000-0000-000000000000")
                ) {
                    return { ...base, disabled: true };
                }
                /* OMD0000 CanShowImportSerialNumberEntryForm: regular order (RECORDTYPE 'R'),
                   not committed (STATUS 'Z'), header saved. Header-level op — no detail row needed. */
                if (id === "UpdateSerialNumbers") {
                    const headerId = props.formFields?.ROWID;
                    const headerSaved =
                        headerId && headerId !== "00000000-0000-0000-0000-000000000000";
                    const layoutRowId = props.formFields?.RLayoutId;
                    const enabled =
                        headerSaved &&
                        props.formFields?.RECORDTYPE === RecordTypes.Record &&
                        props.formFields?.STATUS !== TransactionStatus.Committed &&
                        layoutRowId;
                    return { ...base, disabled: !enabled };
                }
                if (id === "ChangeWarehouse" && !formFields.WarehouseID) {
                    return { ...base, disabled: true };
                }
                if (id === "CreateProductionManagementRequirements" && !formFields.ItemCode) {
                    return { ...base, disabled: true };
                }
                if (id === "ImportDetails" && isChargeAndHold(props.formFields.CHARGEANDHOLDTYPE)) {
                    return { ...base, disabled: true };
                }
                if (id === "ResetItemDiscount") {
                    const discountType = props.formFields?.DISCOUNTTYPE;
                    const isItemDiscountType = discountType === "I" || discountType === "B";
                    const chargeAndHoldShipment = isChargeAndHoldShipment(
                        props.formFields?.CHARGEANDHOLDTYPE
                    );
                    const includeDiscountInUnitPrice =
                        props.formFields?.ProfileIncludeDiscountInUnitPrice === YesNo.Yes;
                    const applyMethodSpecifyPrice =
                        formFields.ApplyMethod === ApplyMethod.ApplyMethodSpecifyPrice;
                    const enabled =
                        isItemDiscountType &&
                        !chargeAndHoldShipment &&
                        !includeDiscountInUnitPrice &&
                        !applyMethodSpecifyPrice;
                    return { ...base, disabled: !enabled };
                }
                if (id === "ReviewedInventoryAllItems") {
                    const headerId = props.formFields?.ROWID;
                    const headerSaved =
                        headerId && headerId !== "00000000-0000-0000-0000-000000000000";
                    return { ...base, disabled: !headerSaved };
                }
                /* Delphi uOMD0000 opUndoDetails.Enabled: saved regular order (RECORDTYPE 'R') and not charge and hold. */
                if (id === "UndoDetails") {
                    const headerId = props.formFields?.ROWID;
                    const headerSaved = headerId && headerId !== EMPTY_GUID;
                    const enabled =
                        headerSaved &&
                        props.formFields?.RECORDTYPE === RecordTypes.Record &&
                        !isChargeAndHold(props.formFields?.CHARGEANDHOLDTYPE);
                    return { ...base, disabled: !enabled };
                }
                /* Delphi: both requisition options are hidden/disabled for Charge & Hold orders. */
                if (
                    id === "UpdateRequisitionDetailsForAllItems" ||
                    id === "UpdateRequisitionDetailsForCurrentItem"
                ) {
                    const chargeAndHold = isChargeAndHold(props.formFields?.CHARGEANDHOLDTYPE);
                    if (id === "UpdateRequisitionDetailsForAllItems") {
                        /* bEnabledIfDetailRecordExists: header must be saved (dropdown-level guard) and not Charge & Hold. */
                        return { ...base, disabled: chargeAndHold };
                    }
                    /* bEnabledIfItemExists: current line must carry an item and not be Charge & Hold. */
                    return { ...base, disabled: base.disabled || chargeAndHold || !formFields.itemId };
                }
                return base;
            })
            .filter(Boolean);
        setDropDownItems(items);
    }, [
        formFields.itemId,
        formFields.WarehouseID,
        formFields.ItemCode,
        formFields.DetailType,
        selectedItemKeys,
        props.formFields?.COMMISSIONTYPE,
        props.formFields?.STAGE,
        props.formFields?.STATUS,
        props.formFields?.ROWID,
        props.formFields?.RECORDTYPE,
        props.formFields?.TRANSACTIONTYPE,
        props.formFields?.DISCOUNTTYPE,
        props.formFields?.CHARGEANDHOLDTYPE,
        props.formFields?.ProfileIncludeDiscountInUnitPrice,
        props.formFields?.INVENTORYREVIEW,
        formFields.ApplyMethod,
    ]);

    useEffect(() => {
        setActionDropDownItems();
    }, [selectedItemKeys, setActionDropDownItems]);

    const handleResetDefaultFreightRatePerItem = useCallback(async () => {
        const detailRowId = formFields?.Rowid;
        if (!detailRowId || detailRowId === "00000000-0000-0000-0000-000000000000") {
            alert(MESSAGES.SELECT_TRANSACTION_DETAIL_ROW, MESSAGES.ERROR);
            return;
        }
        if (props.formFields?.RECORDTYPE !== "R") {
            return;
        }
        const grid = dataGrid.current?.instance();
        if (!grid) {
            return;
        }
        const rowIndex = grid.getRowIndexByKey(detailRowId);
        if (rowIndex < 0) {
            alert(MESSAGES.SELECT_TRANSACTION_DETAIL_ROW, MESSAGES.ERROR);
            return;
        }

        setLoadPanelVisible(true);
        try {
            const params = { detailRowId };
            const priceScheduleRowId = props.formFields?.RPriceScheduleHeader;
            if (priceScheduleRowId && priceScheduleRowId !== "00000000-0000-0000-0000-000000000000") {
                params.priceScheduleRowId = priceScheduleRowId;
            }
            const res = await axios.get(
                `${window._env_.REACT_APP_APIS}/${routes.OM.GetDefaultFreightRatePerItem}`,
                {
                    params,
                    headers: { Authorization: `Bearer ${accessToken}` },
                }
            );
            const payload = res.data?.freightRatePerItem != null && typeof res.data.value === "object" ? res.data.value : res.data;
            if (!payload?.success) {
                alert(payload?.message || MESSAGES.ERROR, MESSAGES.ERROR);
                return;
            }
            const freightRate = payload.freightRatePerItem ?? 0;

            grid.beginUpdate();
            grid.cellValue(rowIndex, "FreightRatePerItem", freightRate);
            grid.cellValue(rowIndex, "FreightRatePerItemChange", "N");
            grid.endUpdate();

            setformFields((prev) => ({
                ...prev,
                Freightrateperitem: freightRate,
                FreightRatePerItemChange: "N",
            }));

            await grid.saveEditData();
            if (props.changeTotals) {
                props.changeTotals(props.formFields.ROWID, props.formFields.SHIPPINGDATE);
            }
        } catch (err) {
            const msg = err.response?.data?.message || err.message;
            alert(typeof msg === "string" ? msg : JSON.stringify(msg), MESSAGES.ERROR);
        } finally {
            setLoadPanelVisible(false);
        }
    }, [
        accessToken,
        formFields?.Rowid,
        props.formFields?.RECORDTYPE,
        props.formFields?.ROWID,
        props.formFields?.SHIPPINGDATE,
        props.formFields?.RPriceScheduleHeader,
        props.changeTotals,
    ]);

    const handleSortDetailRecords = useCallback(async (sortBy, descending) => {
        const headerId = props.formFields?.ROWID;
        if (!headerId || headerId === "00000000-0000-0000-0000-000000000000") {
            alert(MESSAGES.PLEASE_SELECT_TRANSACTION, MESSAGES.ERROR);
            return;
        }
        const useLineNumbers = props.formFields?.ProfileUseLineNumbers;
        let renumber = false;
        if (useLineNumbers && useLineNumbers !== YesNo.No) {
            renumber = await confirm(MESSAGES.CONFIRM_RESEQUENCE_LINE_NUMBERS, MESSAGES.CONFIRM);
        }
        if (!renumber) {
            detailSortRef.current = { orderBy: sortBy, descending };
            dataGrid.current.instance().refresh();
            return;
        }
        setLoadPanelVisible(true);
        try {
            const res = await axios.post(
                `${window._env_.REACT_APP_APIS}/${routes.OM.SortDetailRecords}`,
                {
                    RTransactionheader: headerId,
                    SortBy: sortBy,
                    SortDescending: descending,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            const payload = res.data?.value != null && typeof res.data.value === "object" ? res.data.value : res.data;
            if (payload?.success === false) {
                alert(payload?.message || MESSAGES.ERROR, MESSAGES.ERROR);
                return;
            }
            detailSortRef.current = null;
            dataGrid.current.instance().refresh();
            if (props.onTransactionDetailDataChanged) {
                props.onTransactionDetailDataChanged();
            }
        } catch (err) {
            const msg = err.response?.data?.message || err.message;
            alert(typeof msg === "string" ? msg : JSON.stringify(msg), MESSAGES.ERROR);
        } finally {
            setLoadPanelVisible(false);
        }
    }, [accessToken, props.formFields?.ROWID, props.formFields?.ProfileUseLineNumbers, props.onTransactionDetailDataChanged]);

    /**
     * OMD0000.opSubstituteItems: fetch the substitute items for the current inventory
     * detail line. When none exist show the legacy "no substitute items" message,
     * otherwise open the grid popup.
     */
    const handleSubstituteItems = useCallback(async () => {
        if (formFields.DetailType !== DetailTypes.Item || !formFields.itemId) {
            return;
        }
        setLoadPanelVisible(true);
        try {
            const response = await axios.get(
                `${window._env_.REACT_APP_APIS}/${routes.IM.GetSubstituteItemsDetails}`,
                {
                    params: { rItem: formFields.itemId },
                    headers: {
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            const data = Array.isArray(response.data.data) ? response.data.data : [];
            if (data.length === 0) {
                alert(MESSAGES.NO_SUBSTITUTE_ITEMS, MESSAGES.INFORMATION);
                return;
            }
            setShowSubstituteItems({ visible: true, data });
        } catch (error) {
            alert(error.response?.data?.message || error.message || MESSAGES.NO_SUBSTITUTE_ITEMS, MESSAGES.ERROR);
        } finally {
            setTimeout(hideLoadPanel, 300);
            setLoadPanelVisible(false);
        }
    }, [accessToken, formFields.DetailType, formFields.itemId, hideLoadPanel]);

    const onItemClick = async (e) => {
        if (e.itemData?.disabled) return;
        const id = e.itemData?.id;
        if (id === "DisplayLocationHistory") {
            setShowLocationHistory({ visible: true, RItem: formFields.itemId, RLot: formFields.lotId });
        }
        if (id === "DisplayItemStatus") {
            if (formFields.DetailType !== "I" || !formFields.itemId) {
                return;
            }
            setShowImItemStatus({
                visible: true,
                rItem: formFields.itemId,
                rLot: formFields.lotId,
                itemCode: formFields.ItemCode,
                warehouseName: formFields.WarehouseName,
                lotCode: formFields.LotCode,
                sublotCode: null,
                unitOfMeasure: formFields.UnitOfMeasure || formFields.InventoryUnitUOM,
            });
        }
        if (id === "DisplayItemPrices") {
            if (formFields.DetailType !== "I" || !formFields.itemId) {
                return;
            }
            setShowItemPrices({
                visible: true,
                rItem: formFields.itemId,
            });
        }
        if (id === "CreateProductionManagementRequirements") {
            await handleCreateProductionManagementRequirements();
        }
       if (id === "ChangeWarehouse") {
           setShowChangeWarehouse({
               visible: true,
               currentWarehouseId: formFields.WarehouseID,
               currentWarehouseName: formFields.WarehouseName || '',
           });
       }
       if (id === "CustomerItemHistory") {
        setShowCustomerItemHistory({visible: true,RItem:formFields.itemId,HeaderRowId:props.formFields.ROWID,CustomerId:props.formFields.R_CUSTOMER});
       }
       if (id === "SubstituteItems") {
           await handleSubstituteItems();
       }
       if (id === "DisplayCostComponents") {
        setShowCostComponents({visible: true,headerRowId:props.formFields.ROWID,detailRowId:formFields.Rowid});
       }
        if (id === "CommitCommission") {
            await handleCommitCommission();
        }
        if (id === "TransactionDetailGrid") {
            const headerId = props.formFields?.ROWID;
            if (!headerId || headerId === "00000000-0000-0000-0000-000000000000") {
                alert(MESSAGES.PLEASE_SELECT_TRANSACTION, MESSAGES.ERROR);
                return;
            }
            setShowTransactionDetailGrid({
                visible: true,
                transactionHeaderId: headerId,
                title: "OM Transaction Detail Grid",
            });
        }
        if (id === "SortDetailRecords") {
            setShowSortDetailRecords(true);
        }
        if (id === "ImportDetails") {
            importDetailsFileInputRef.current.click();
        }
        if (id === "UpdateSerialNumbers") {
            const headerId = props.formFields?.ROWID;
            if (!headerId || headerId === "00000000-0000-0000-0000-000000000000") {
                alert(MESSAGES.PLEASE_SELECT_TRANSACTION, MESSAGES.ERROR);
                return;
            }
            const layoutRowId = props.formFields?.RLayoutId || null;
            setShowSerialImport({ visible: true, headerRowId: headerId, layoutRowId });
        }
        if (id === "OpenTransactionForItemLot") {
            if (formFields.DetailType !== "I" || !formFields.itemId) {
                alert("Select an inventory detail line with an item before opening open transactions.", MESSAGES.ERROR);
                return;
            }
            setShowOpenTransactionForItemLot({
                visible: true,
                itemId: formFields.itemId,
                lotId: formFields.lotId,
                detailRowId: formFields.Rowid,
                title: "Open Transactions for Item/Lot",
            });
        }
        if (id === "ResetDefaultFreightRatePerItem") {
            await handleResetDefaultFreightRatePerItem();
        }
        if (id === "ShowSerialNumberReceiptEntryForm") {
            const detailRowId = formFields.Rowid;
            if (!detailRowId || detailRowId === "00000000-0000-0000-0000-000000000000") {
                return;
            }
            setShowSerialNumberReceipt({ visible: true, detailRowId });
        }
        if (id === "ShowSerialNumberShipmentForm") {
            const detailRowId = formFields.Rowid;
            if (!detailRowId || detailRowId === "00000000-0000-0000-0000-000000000000") {
                return;
            }
            setShowSerialNumberShipment({ visible: true, detailRowId });
        }
        if (id === "ReviewedInventoryAllItems") {
            await handleReviewedInventoryAllItems();
        }
        if (id === "UndoDetails") {
            await handleUndoDetails();
        }
        if (id === "ResetItemDiscount") {
            const headerId = props.formFields?.ROWID;
            if (!headerId || headerId === "00000000-0000-0000-0000-000000000000") {
                alert(MESSAGES.PLEASE_SELECT_TRANSACTION, MESSAGES.ERROR);
                return;
            }
            setShowResetItemDiscount({
                visible: true,
                headerRowId: headerId,
                defaultDetailDiscount: props.formFields?.DEFAULTDETAILDISCOUNT,
            });
        }
        if (id === "UpdateRequisitionDetailsForAllItems") {
            const headerId = props.formFields?.ROWID;
            if (!headerId || headerId === "00000000-0000-0000-0000-000000000000") {
                alert(MESSAGES.PLEASE_SELECT_TRANSACTION, MESSAGES.ERROR);
                return;
            }
            // Delphi opUpdateRequisitionDetailsForAllSalesOrderDetails: gather every order line's item code
            // (like cdsItemCodes) and filter requisitions by that set.
            let codes = [];
            try {
                const grid = dataGrid.current?.instance();
                const store = grid?.getDataSource()?.store();
                const res = store ? await store.load() : [];
                const rows = Array.isArray(res) ? res : (res?.data ?? []);
                codes = [...new Set(rows.map((r) => r.ItemCode).filter((c) => c && String(c).trim()))];
            } catch {
                codes = [];
            }
            if (codes.length === 0) {
                alert(MESSAGES.NO_ITEM_LINES_FOUND_ON_ORDER, MESSAGES.ERROR);
                return;
            }
            setShowRequisitionDetails({
                visible: true,
                ItemCode: codes.join(ItemCodeSeparator),
                consigneeRowId: props.formFields?.R_SHIPPER,
                title: MESSAGES.REQUISITION_DETAIL_VIEWER_TITLE,
            });
        }
        if (id === "UpdateRequisitionDetailsForCurrentItem") {
            const headerId = props.formFields?.ROWID;
            if (!headerId || headerId === "00000000-0000-0000-0000-000000000000") {
                alert(MESSAGES.PLEASE_SELECT_TRANSACTION, MESSAGES.ERROR);
                return;
            }
            if (!formFields.itemId) {
                alert(MESSAGES.SELECT_DETAIL_LINE_WITH_ITEM, MESSAGES.ERROR);
                return;
            }
            // Current line: filter requisitions by this line's item code.
            setShowRequisitionDetails({
                visible: true,
                ItemCode: formFields.ItemCode,
                consigneeRowId: props.formFields?.R_SHIPPER,
                title: MESSAGES.REQUISITION_DETAIL_VIEWER_TITLE,
            });
        }
    };

    const getImportClientPathForServer = (f) => {
        if (!f) return "";
        if (typeof f.path === "string" && f.path.trim().length > 0) return f.path.trim();
        return "";
    };

    const getImportSourceDisplayLabel = (f) => {
        if (!f) return "";
        if (typeof f.path === "string" && f.path.trim().length > 0) return f.path.trim();
        if (typeof f.webkitRelativePath === "string" && f.webkitRelativePath.trim().length > 0)
            return f.webkitRelativePath.trim();
        if (typeof f.name === "string" && f.name.trim().length > 0) return f.name.trim();
        return "";
    };

    const buildImportDetailsLogHtml = (data) => {
        const root = data && typeof data === "object" && data.value != null && typeof data.value === "object"
            ? data.value
            : data;
        const pick = (a, b) => (root[a] !== undefined && root[a] !== null ? root[a] : root[b]);
        const linesImported = Number(pick("linesImported", "LinesImported")) || 0;
        const importAllowed = Boolean(pick("importAllowed", "ImportAllowed"));
        const previewOnly = Boolean(pick("previewOnly", "PreviewOnly"));
        const successFlag = pick("success", "Success");

        const normalizeLines = (v, keepEmptyLines) => {
            if (v == null) return [];
            if (Array.isArray(v)) {
                const arr = v.map((x) => (x != null ? String(x) : ""));
                return keepEmptyLines ? arr : arr.map((x) => x.trim()).filter(Boolean);
            }
            if (typeof v === "string") {
                const t = v.trim();
                if (t.startsWith("[") && t.endsWith("]")) {
                    try {
                        const parsed = JSON.parse(t);
                        if (Array.isArray(parsed)) return normalizeLines(parsed, keepEmptyLines);
                    } catch {
                        /* treat as plain string */
                    }
                }
            }
            if (typeof v === "object") {
                const keys = Object.keys(v);
                const numericKeys = keys.filter((k) => /^\d+$/.test(k));
                if (numericKeys.length > 0 && numericKeys.length === keys.length) {
                    const arr = numericKeys
                        .sort((a, b) => Number(a) - Number(b))
                        .map((k) => (v[k] != null ? String(v[k]) : ""));
                    return keepEmptyLines ? arr : arr.map((x) => x.trim()).filter(Boolean);
                }
            }
            if (typeof v === "string" && (/[\r\n]/.test(v))) {
                const parts = v.split(/\r\n|\r|\n/);
                return keepEmptyLines ? parts : parts.map((x) => x.trim()).filter(Boolean);
            }
            const s = String(v);
            return keepEmptyLines ? [s] : [s.trim()].filter(Boolean);
        };

        const errs = normalizeLines(pick("errors", "Errors"), false);
        const warns = normalizeLines(pick("warnings", "Warnings"), false);
        const msgs = normalizeLines(pick("messages", "Messages"), true);

        const esc = (s) =>
            String(s)
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/"/g, "&quot;");

        const detailBlock = (title, lines) => {
            if (!lines.length) return "";
            const body = lines.map((line) => esc(line)).join("<br/>");
            return `<p style="margin:10px 0 4px 0;font-weight:600;">${esc(title)}</p>` +
                `<div style="white-space:pre-wrap;word-break:break-word;margin:0;padding:8px 10px;background:#f5f5f5;border-radius:4px;font-family:inherit;font-size:13px;line-height:1.45;">${body}</div>`;
        };

        let html = `<p style="margin-top:0;"><strong>${esc("Lines imported")}:</strong> ${linesImported}</p>`;
        if (previewOnly) {
            html += `<p style="margin:0 0 8px 0;font-size:13px;color:#555;">${esc("Preview — lines are not saved until you choose Import.")}</p>`;
        }
        html += detailBlock("Messages", msgs);
        html += detailBlock("Warnings", warns);
        if (errs.length) {
            html += detailBlock("Errors", errs);
        }
        if (!previewOnly && successFlag !== false && !errs.length && !msgs.length && !warns.length && linesImported > 0) {
            html += `<p style="margin-bottom:0;">${esc("Import completed successfully.")}</p>`;
        }
        return {
            html: `<div style="text-align:left;max-width:560px;white-space:normal;">${html}</div>`,
            importAllowed,
            linesImported,
            successFlag,
            errs,
        };
    };

    const closeImportDetailsPreview = useCallback(() => {
        importDetailsPendingFileRef.current = null;
        setImportDetailsPreview({ visible: false, html: "", importAllowed: false, sourceLabel: "" });
    }, []);

    const onImportDetailsCommit = useCallback(async () => {
        const file = importDetailsPendingFileRef.current;
        const headerId = props.formFields?.ROWID;
        if (!file || !headerId || headerId === "00000000-0000-0000-0000-000000000000") {
            return;
        }
        setLoadPanelVisible(true);
        try {
            const formData = new FormData();
            formData.append("file", file);
            const fullPath = getImportClientPathForServer(file);
            if (fullPath) formData.append("clientFilePath", fullPath);
            const params = { headerRowId: headerId, preview: false };
            if (fullPath) params.clientFilePath = fullPath;
            const res = await axios.post(
                `${window._env_.REACT_APP_APIS}/${routes.OM.ImportSalesOrderDetails}`,
                formData,
                {
                    params,
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            const built = buildImportDetailsLogHtml(res.data || {});
            if (built.successFlag === false || built.errs.length) {
                await alert(
                    built.errs.length
                        ? `<div style="text-align:left;max-width:560px;white-space:normal;">${built.html}</div>`
                        : `<div style="text-align:left;"><p>${MESSAGES.ERROR}</p></div>`,
                    MESSAGES.ERROR
                );
                return;
            }
            closeImportDetailsPreview();
            if (built.linesImported > 0) {
                const grid = dataGrid.current?.instance();
                if (grid) grid.refresh();
                if (props.changeTotals) props.changeTotals(props.formFields.ROWID, props.formFields.SHIPPINGDATE);
                if (props.onTransactionDetailDataChanged) props.onTransactionDetailDataChanged();
            }
        } catch (err) {
            const msg = err.response?.data?.message || err.response?.data || err.message;
            alert(typeof msg === "string" ? msg : JSON.stringify(msg), MESSAGES.ERROR);
        } finally {
            setLoadPanelVisible(false);
        }
    }, [accessToken, props, closeImportDetailsPreview]);

    const onImportDetailsFileChange = async (e) => {
        const file = e.target?.files?.[0];
        e.target.value = "";
        const headerId = props.formFields?.ROWID;
        if (!file || !headerId || headerId === "00000000-0000-0000-0000-000000000000") {
            return;
        }
        importDetailsPendingFileRef.current = file;
        setLoadPanelVisible(true);
        try {
            const formData = new FormData();
            formData.append("file", file);
            const fullPath = getImportClientPathForServer(file);
            if (fullPath) formData.append("clientFilePath", fullPath);
            const params = { headerRowId: headerId, preview: true };
            if (fullPath) params.clientFilePath = fullPath;
            const res = await axios.post(
                `${window._env_.REACT_APP_APIS}/${routes.OM.ImportSalesOrderDetails}`,
                formData,
                {
                    params,
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            const built = buildImportDetailsLogHtml(res.data || {});
            setImportDetailsPreview({
                visible: true,
                html: built.html,
                importAllowed: built.importAllowed,
                sourceLabel: getImportSourceDisplayLabel(file),
            });
        } catch (err) {
            importDetailsPendingFileRef.current = null;
            const msg = err.response?.data?.message || err.response?.data || err.message;
            alert(typeof msg === "string" ? msg : JSON.stringify(msg), MESSAGES.ERROR);
        } finally {
            setLoadPanelVisible(false);
        }
    };

    const handleCommitCommission = useCallback(async () => {
        const headerRowId = props.formFields?.ROWID;
        if (!headerRowId) {
            alert(MESSAGES.SELECT_TRANSACTION_DETAIL_ROW, MESSAGES.ERROR);
            return;
        }
        setLoadPanelVisible(true);
        try {
            const confirmed = await confirm(MESSAGES.CONFIRM_COMMIT_COMMISSIONS, MESSAGES.CONFIRM);
            if (!confirmed) return;
            const commitRes = await axios.post(
                `${window._env_.REACT_APP_APIS}/om/SalesOrderDetailOperations/CommitCommissions`,
                null,
                { params: { headerRowId }, headers: { Authorization: `Bearer ${accessToken}` } }
            );
            const { success, message: commitMsg } = commitRes.data || {};
            if (success) {
                notify({ message: commitMsg, width: 300 }, "success", 4000);
            } else {
                alert(commitMsg || MESSAGES.COMMIT_FAILED, MESSAGES.ERROR);
            }
        } catch (err) {
            const msg = err.response?.data?.message || err.message;
            alert(msg, MESSAGES.ERROR);
        } finally {
            setLoadPanelVisible(false);
        }
    }, [props.formFields?.ROWID, props.oidc?.user?.access_token]);

    /**
     * Shared runner for header-level detail operations (confirm → POST → toast → refresh).
     * Pass `body` for endpoints that take a JSON payload; otherwise the header key is sent as the
     * `headerRowId` query parameter. The grid/totals refresh runs in `finally` so a partial server
     * change never leaves stale rows on screen (matches the legacy RefreshDetail-in-finally
     * behaviour). Returns true only when the server reports success.
     */
    const runHeaderOperation = useCallback(async ({ route, body, confirmMessage, successMessage, onSuccess }) => {
        const headerId = props.formFields?.ROWID;
        if (!headerId || headerId === EMPTY_GUID) {
            alert(MESSAGES.PLEASE_SELECT_TRANSACTION, MESSAGES.ERROR);
            return false;
        }
        if (confirmMessage) {
            const confirmed = await confirm(confirmMessage, MESSAGES.CONFIRM);
            if (!confirmed) return false;
        }
        setLoadPanelVisible(true);
        let succeeded = false;
        try {
            const url = `${window._env_.REACT_APP_APIS}/${route}`;
            const authHeader = { Authorization: `Bearer ${accessToken}` };
            const res = body
                ? await axios.post(url, body, {
                    headers: { "Content-Type": "application/json", ...authHeader },
                })
                : await axios.post(url, null, {
                    params: { headerRowId: headerId },
                    headers: authHeader,
                });
            const { success, message } = res.data || {};
            if (success) {
                succeeded = true;
                notify({ message: successMessage, width: 300 }, "success", 3000);
                if (onSuccess) onSuccess();
            } else {
                alert(message || MESSAGES.ERROR, MESSAGES.ERROR);
            }
        } catch (err) {
            const msg = err.response?.data?.message || err.message;
            alert(typeof msg === "string" ? msg : JSON.stringify(msg), MESSAGES.ERROR);
        } finally {
            const grid = dataGrid.current?.instance();
            if (grid) grid.refresh();
            if (props.changeTotals) {
                props.changeTotals(props.formFields.ROWID, props.formFields.SHIPPINGDATE);
            }
            if (props.onTransactionDetailDataChanged) {
                props.onTransactionDetailDataChanged();
            }
            setLoadPanelVisible(false);
        }
        return succeeded;
    }, [accessToken, props.formFields?.ROWID, props.formFields?.SHIPPINGDATE, props.changeTotals, props.onTransactionDetailDataChanged]);

    /** Delphi opReviewedInventoryAllItemsClick — marks every pending-review line ('Y' -> 'R') for the
     *  whole order and clears the header review flag. Sending no detail Rowid selects that scope on
     *  the shared ReviewedInventory endpoint. */
    const handleReviewedInventoryAllItems = useCallback(
        () => runHeaderOperation({
            route: routes.OM.ReviewedInventory,
            body: { RTransactionheader: props.formFields?.ROWID, Stage: props.formFields?.STAGE },
            confirmMessage: MESSAGES.MARK_ALL_ITEMS_REVIEWED_CONFIRM,
            successMessage: MESSAGES.INVENTORY_REVIEW_COMPLETED,
            onSuccess: () =>
                setformFields((prev) => ({ ...prev, Inventoryreview: InventoryReview.Review })),
        }),
        [runHeaderOperation, props.formFields?.ROWID, props.formFields?.STAGE]
    );

    /** Delphi opUndoDetails → RestoreOriginalDetail: undo automatic lot selection for the whole order
     *  (deletes the auto-created detail records via SPOM_DeleteCreatedDetails and restores original quantities). */
    const handleUndoDetails = useCallback(
        () => runHeaderOperation({
            route: routes.OM.UndoDetails,
            confirmMessage: MESSAGES.UNDO_LOT_SELECTION_CONFIRM,
            successMessage: MESSAGES.UNDO_LOT_SELECTION_SUCCESS,
        }),
        [runHeaderOperation]
    );

    /** Local stage check before opening PM dialog; full validation is done by the backend. */
    const validateStageForPMRequirements = useCallback(() => {
        const stage = props.formFields?.STAGE ?? props.stage;
        if (stage === "L") {
            return { allowed: false, message: "Creation of PM Requirements are not allowed in Canceled stage." };
        }
        return { allowed: true };
    }, [props.formFields?.STAGE, props.stage]);

    const handleCreateProductionManagementRequirements = useCallback(async () => {
        const headerRowId = props.formFields?.ROWID;
        const detailRowId = formFields?.Rowid;
        const itemRowId = formFields?.itemId;
        if (!headerRowId || !detailRowId) {
            alert("Please select a detail line.", MESSAGES.ERROR);
            return;
        }
        const stageValidation = validateStageForPMRequirements();
        if (!stageValidation.allowed) {
            alert(stageValidation.message, MESSAGES.ERROR);
            return;
        }
        setLoadPanelVisible(true);
        try {
            const res = await axios.get(
                `${window._env_.REACT_APP_APIS}/${routes.OM.ValidateAndGetPMRequirementsFormData}`,
                {
                    params: { headerRowId, detailRowId, isFromOption: true },
                    headers: { Authorization: `Bearer ${accessToken}`, access_token: accessToken }
                }
            );
            setLoadPanelVisible(false);
            if (!res.data?.allowed || !res.data?.formData) {
                if (res.data?.message) alert(res.data.message, MESSAGES.ERROR);
                return;
            }
            let data = res.data.formData;
            data.ItemNetAvailable = formFields.ItemNetAvailable;

            const kitListEmpty =
                !Array.isArray(data.KitDetails) || data.KitDetails.length === 0;
            const itemForKit =
                data.ProdItemRowId ||
                data.SoldItemRowId ||
                formFields.itemId;
            const warehouseForKit = data.WarehouseId || formFields.WarehouseID;

            if (kitListEmpty && itemForKit && warehouseForKit) {
                try {
                    const kitRes = await axios.get(
                        `${window._env_.REACT_APP_APIS}/om/SaleOrder/GetKitDetails`,
                        {
                            params: {
                                itemId: itemForKit,
                                warehouseId: warehouseForKit,
                            },
                            headers: {
                                Authorization: `Bearer ${accessToken}`,
                                access_token: accessToken,
                            },
                        }
                    );
                    const list = kitRes.data;
                    if (Array.isArray(list) && list.length) {
                        data = {
                            ...data,
                            KitDetails: list.map((row) => ({
                                RItem: row.ItemRowid ?? row.itemRowid,
                                RLot: row.LotRowid ?? row.lotRowid,
                                ItemCode: row.ItemCode ?? row.itemCode,
                                LotCode: row.LotCode ?? row.lotCode,
                                RequiredUnitQuantity:
                                    row.Quantity != null ? Number(row.Quantity) : 0,
                                NetAvailable:
                                    row.NetAvailable != null
                                        ? Number(row.NetAvailable)
                                        : null,
                                Quantity:
                                    row.Quantity != null ? Number(row.Quantity) : 0,
                            })),
                        };
                    }
                } catch {
                    /* keep empty KitDetails from validation response */
                }
            }

            setPmRequirementsModal({ visible: true, formData: data });
        } catch (err) {
            setLoadPanelVisible(false);
            const msg = err.response?.data?.message || err.message || "Failed to open PM Requirements.";
            alert(msg, MESSAGES.ERROR);
        }
    }, [formFields, props.formFields, props.stage, accessToken, validateStageForPMRequirements]);

    const handlePMRequirementsYes = useCallback(async (request) => {
        setLoadPanelVisible(true);
        request.RProfile = props.formFields.R_PROFILE;
        try {
            const res = await axios.post(
                `${window._env_.REACT_APP_APIS}/${routes.OM.ValidateAndCreateProductionManagementRequirements}`,
                request,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${accessToken}`,
                        access_token: accessToken
                    }
                }
            );
            if (res.data?.success) {
                notify(
                    {
                        message: res.data.message || "Production Management requirements created.",
                        width: 200,
                    },
                    'success',
                    3000,
                );
                if (dataGrid.current && dataGrid.current.instance) dataGrid.current.instance().refresh();
                if (props.changeTotals) props.changeTotals(props.formFields.ROWID, props.formFields.SHIPPINGDATE);
            } else {
                alert(res.data?.message || "Failed to create PM requirements.", MESSAGES.ERROR);
            }
        } catch (err) {
            const msg = err.response?.data?.message || err.message || "Failed to create Production Management requirements.";
            alert(msg, MESSAGES.ERROR);
        } finally {
            setLoadPanelVisible(false);
        }
    }, [accessToken, props.formFields, props.changeTotals]);

    const renderItem = (itemData) => {
        const isHeader = OMLocationOperations[itemData.id]?.isHeader === true;
        if (isHeader) {
            return <div style={{ fontWeight: "bold", borderBottom: "1px solid #ccc" }}>{itemData.name}</div>;
        }
        const isDisabled = itemData.disabled === true;
        return (
            <span style={{
                opacity: isDisabled ? 0.5 : 1,
                cursor: isDisabled ? "not-allowed" : "pointer",
                pointerEvents: isDisabled ? "none" : "auto",
            }}>
                {itemData.name}
            </span>
        );
    };
    return (
        <div>
            <input
                ref={importDetailsFileInputRef}
                type="file"
                accept=".txt,.csv,text/plain,*/*"
                style={{ display: "none" }}
                onChange={onImportDetailsFileChange}
            />
            <LoadPanel
               shadingColor="rgba(0,0,0,0.4)"
               position={position}
               onHiding={hideLoadPanel}
               visible={loadPanelVisible}
               showIndicator={true}
               shading={true}
               showPane={true}
               hideOnOutsideClick={false}
                />
            <Popup
                visible={importDetailsPreview.visible}
                onHiding={closeImportDetailsPreview}
                dragEnabled={true}
                hideOnOutsideClick={false}
                showTitle={true}
                title="Import OM Sales Order Details"
                width={620}
                height="auto"
                showCloseButton={true}
            >
                <div style={{ padding: "4px 8px 12px 8px", display: "flex", flexDirection: "column", maxHeight: "min(85vh, 720px)", minHeight: 0 }}>
                    {/* The "Processing file ..." entry rendered by the backend inside the messages list is the single
                        source-file display (Delphi OMD0033 popup style); no separate header label is shown. */}
                    <div
                        style={{
                            overflowY: "auto",
                            overflowX: "hidden",
                            maxHeight: "min(52vh, 460px)",
                            minHeight: 100,
                            flex: "1 1 auto",
                            minWidth: 0,
                            WebkitOverflowScrolling: "touch",
                        }}
                    >
                        <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(importDetailsPreview.html) }} />
                    </div>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: 10,
                            paddingTop: 12,
                            borderTop: "1px solid #e0e0e0",
                            marginTop: 8,
                        }}
                    >
                        <Button
                            text="Import"
                            type="default"
                            disabled={!importDetailsPreview.importAllowed}
                            onClick={onImportDetailsCommit}
                        />
                        <Button text="Exit" onClick={closeImportDetailsPreview} />
                    </div>
                </div>
            </Popup>
            <DataGrid
                key={headerRowId || "om-detail-no-header"}
onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
               dataSource={dataSource}
                ref={dataGrid}
                selectedRowKeys={selectedItemKeys}
                showBorders={true}
                onSelectionChanged={handleCellValueChanged}
                rowAlternationEnabled={true}
                allowColumnReordering={true}
                allowColumnResizing={true}
                columnAutoWidth={true}
                onRowUpdated={handleValueChange}
                onRowInserted={handleValueChange}
                onInitNewRow={onInitNewRow}
                onEditCanceled={onEditCanceled}
                height="40vh"
                onEditingStart={(e) => onEditingStart(e, dataGrid)}
            >
                <Selection mode="single" />
                <Export enabled={true} allowExportSelectedData={true} />
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Sorting visible={true} mode="multiple" />
                <Editing
                    mode="cell"
                    allowUpdating={true}
                    allowAdding={true}
                />
                <FilterRow visible={true} />
                <Column
                    dataField="Rowid"
                    caption="rowId#"
                    visible={false}
                    showInColumnChooser={false}
                />
                <Column
                    dataField="Linenumber"
                    dataType="number"
                    caption="Line#"
                    allowEditing={false}
                />
                <Column
                    dataField="DetailType"
                    caption="Type"
                >
                    <Lookup
                        dataSource={recordTypes}
                        valueExpr="ID"
                        displayExpr="Text"
                    />
                </Column>
                <Column dataField="WarehouseID" caption='WarehouseID' visible={false} showInColumnChooser={false}/>
                <Column dataField="WarehouseName" caption='Warehouse' editCellRender={renderWarehouseCell} setCellValue={setStateValue} >
                    <RequiredRule message="The Warehouse field is required." />
                </Column>
                <Column dataField="itemId" caption='Item Id' visible={false} showInColumnChooser={false}/>
                <Column dataField="ItemCode" editCellRender={renderItemCell} setCellValue={setItemValue} caption='Item' >

                    <RequiredRule message="The Item Code field is required." />
                </Column>

                <Column dataField="ItemDesc1" caption='Item Des - 1' allowEditing={false} />

                <Column
                    dataField="Itemsupccode"
                    caption='Alternate SKU'
                    allowSorting={false}
                    visible={false}
                    editCellRender={(cellElement) => {
                        // Editable only while adding a new row and before an item is picked; otherwise render the
                        // value as read-only text. onEditorPreparing/e.cancel can't gate a custom editCellRender,
                        // so the guard lives here (once an Item is chosen it auto-fills and locks the SKU).
                        const itemSelected = !!(cellElement.data?.ItemCode || cellElement.data?.itemId);
                        if (!cellElement.row?.isNewRow || itemSelected) {
                            return <span>{cellElement.value ?? ""}</span>;
                        }
                        return RenderSelectBoxCell({
                            loadUrl: `${window._env_.REACT_APP_APIS}/${routes.IM.GetItemsForAlternateSku}`,
                            // Same price-schedule scoping as the Item cell (LoadItems), so both pickers offer the
                            // same items on a schedule-restricted order.
                            loadParams: {
                                RPriceScheduleHeader: function () { return props.formFields.RPriceScheduleHeader; },
                                ApplyMethod: function () { return formFields.ApplyMethod; },
                                AllowUnSpecified: function () { return formFields.AllowUnSpecified; },
                            },
                            key: "rowId",
                            valueExpr: "rowId",
                            displayExpr: "itemSupcCode",
                            accessToken: accessToken,
                            sort: [{ selector: "itemCode", desc: false }],
                            defaultValue: cellElement.data?.itemId,
                            onValueChangeCallback: (value, text, additionalData) => {
                                cellElement.setValue(additionalData);
                            },
                        });
                    }}
                    setCellValue={(rowData, newValue) => {
                        // Picking a SKU stamps the matching item onto the row so the Item cell auto-populates.
                        if (newValue) {
                            stampItemOntoRow(rowData, newValue);
                            rowData.ItemDesc1 = newValue.description1;
                            rowData.WarehouseID = newValue.rWarehouse;
                            rowData.WarehouseName = newValue.warehouseName;
                            WarehouseId = newValue.rWarehouse;
                        } else {
                            rowData.Itemsupccode = null;
                        }
                    }}
                />

                {/* Legacy OMD0014 "Items Based On Customer SKU", as a cell lookup instead of a popup.
                    OMD0000.CallCustomerSKUGrid only offered the popup while adding a line that had no item
                    and no customer SKU yet, so the editor reuses the Alternate SKU cell's guard above. */}
                <Column
                    dataField="CustomerItem"
                    caption='Customer SKU'
                    allowSorting={false}
                    visible={false}
                    editCellRender={(cellElement) => {
                        // Same gate as the Alternate SKU cell: editable only on a new row before an item is
                        // picked. OMD0014.btnOKClick locks both SKU fields once it stamps an item, and the
                        // guard has to live here because onEditorPreparing/e.cancel can't gate editCellRender.
                        const itemSelected = !!(cellElement.data?.ItemCode || cellElement.data?.itemId);
                        if (!cellElement.row?.isNewRow || itemSelected) {
                            return <span>{cellElement.value ?? ""}</span>;
                        }
                        return RenderSelectBoxCell({
                            loadUrl: `${window._env_.REACT_APP_APIS}/${routes.IM.GetCustomerCrossReferences}`,
                            // No RCustomer on the request: legacy OMD0014 listed only the order customer's
                            // IMCRGROUP, this picker lists every cross-reference in the company so a line can
                            // be entered from any of them. Which item each one resolves to is in displayExpr.
                            // pickKey, not rowId: one cross-reference is listed once per lot of its
                            // item, so its ROWID is not unique down the list.
                            key: "pickKey",
                            valueExpr: "pickKey",
                            displayExpr: formatCustomerCrossRef,
                            loadParams: {
                                       RCustomer: function () { return props.formFields.R_CUSTOMER; },
                                        },
                            // displayExpr is a function, so the search field has to be named explicitly -
                            // the typed text is filtered on the server, and it is the customer's SKU the
                            // user is typing (legacy OMD0014 searched edtCustomerSKU the same way).
                            searchExpr: "customerItem",
                            accessToken: accessToken,
                            // No client sort: it would replace the service's ITEMCODE, KEYSEQUENCE order,
                            // which is the order the legacy grid listed these rows in.
                            // valueExpr is the picker's own key, which the detail row does not keep - the
                            // editor only opens on a new, item-less row, so it always starts empty. null
                            // rather than "": "" makes the editor resolve the value through byKey(""), one
                            // request per editor opened, for a key that cannot match anything.
                            defaultValue: null,
                            onValueChangeCallback: (value, text, additionalData) => {
                                cellElement.setValue(additionalData);
                            },
                        });
                    }}
                    setCellValue={(rowData, newValue) => {
                        if (newValue) {
                            stampCustomerCrossRefOntoRow(rowData, newValue);
                        } else {
                            clearCustomerCrossRefFromRow(rowData);
                        }
                    }}
                />

                <Column dataField="lotId" caption='lot Id' visible={false} showInColumnChooser={false}/>
                <Column dataField="LotCode" caption='Lot' editCellRender={renderLotCell} setCellValue={setLotValue} />

                <Column dataField="Quantityordered" caption='Orderd' format={{
                    type: 'fixedPoint',
                    precision: 2
                }} />
                <Column dataField="Quantityshipped" allowEditing={isShiped} caption='Shipped' format={{
                    type: 'fixedPoint',
                    precision: 2
                }} />
                <Column dataField="QuantityBackOrder" allowEditing={isShiped} caption='Back Order' format={{
                    type: 'fixedPoint',
                    precision: 2
                }} />
                <Column dataField="UnitPrice" caption='Unit Price' format={{
                    type: 'currency',
                    precision: 2,
                    currency: 'USD',
                    useGrouping: true
                }} />
                <Column dataField="Amount" caption='Amount' allowEditing={false} format={{
                    type: 'currency',
                    precision: 2,
                    currency: 'USD',
                    useGrouping: true
                }} />
                <Column dataField="FreightRatePerItem" visible={false}  showInColumnChooser={false}/>
                <Column dataField="FreightRatePerItemChange" visible={false}  showInColumnChooser={false}/>
                <Toolbar>
                    <Item location="after">
                        <Button
                            text="Save"
                            type="default"
                            onClick={updateRecords}
                            className="accordianButton"
                        />
                    </Item>
                    <Item
                        name="addRowButton"
                    />
                    <Item location="after">
                        <Button
                            onClick={deleteRecords}
                            icon="trash"
                            disabled={!selectedItemKeys.length}
                        />
                    </Item>
                    <Item location="after">
                            <DropDownButton
                                icon="fa fa-cogs"
                                stylingMode="text"
                                dropDownOptions={buttonDropDownOptions}
                                items={dropDownItems}
                                onItemClick={onItemClick}
                                displayExpr="name"
                                keyExpr="id"
                                disabled={
                                    !props.formFields?.ROWID ||
                                    props.formFields.ROWID === "00000000-0000-0000-0000-000000000000"
                                }
                                itemRender={renderItem}
                                />
                     </Item>
                      <Item location="after">
                        <Button
                            text={MESSAGES.SELECT_ITEMS_TITLE}
                            onClick={() =>
                                setShowItemRange({
                                    visible: true,
                                    // Held until the range dialog is answered, then handed to the picker as-is.
                                    pending: {
                                        visible: true,
                                        headerRowId: props.formFields?.ROWID,
                                        // Same default as a hand-added row when no line is selected (or it has no warehouse).
                                        warehouseId: formFields.WarehouseID ?? defaultDetailWarehouse.id,
                                        warehouseName: formFields.WarehouseName,
                                        // Pricing context from the already-loaded order header (avoids a backend header re-read).
                                        customerId: props.formFields?.R_CUSTOMER,
                                        consigneeId: props.formFields?.R_SHIPPER, // legacy OMD0027 feeds P_SHIPPER as FNIM_GETPRICE @R_Consignee
                                        priceLevel: props.formFields?.PRICELEVEL,
                                        stage: props.formFields?.STAGE,
                                        shippingDate: props.formFields?.SHIPPINGDATE,
                                        transactionDate: props.formFields?.TRANSACTIONDATE,
                                    },
                                })
                            }
                        />
                    </Item>
                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="columnChooserButton" location="after" />
                </Toolbar>
            </DataGrid>
            <TabPanel showNavButtons={true} style={{ height: 'calc(60vh - 200px)' }} >
                <TabItem title="Primary">
                    <PrimaryTab
                        formFields={formFields}
                        setformFields={setformFields}
                        isCommittedTransaction={props.formFields?.STATUS === TransactionStatus.Committed}
                    />
                </TabItem>
                <TabItem title="Additinal">
                    <AdditionalTab formFields={formFields} setformFields={setformFields} ProfileIncludeDiscountInUnitPrice={props.formFields.ProfileIncludeDiscountInUnitPrice}/>
                </TabItem>
                <TabItem title="User Defined">
                    <UserDefinedTab formFields={formFields} setformFields={setformFields} />
                </TabItem>
                <TabItem title="User Defined-2">
                    <UserDefinedTab1 formFields={formFields} setformFields={setformFields} />
                </TabItem>
                <TabItem title="Commissions">
                    <CommissionsTab
                        formFields={formFields}
                        setformFields={setformFields}
                        isReadOnly={props.formFields?.STATUS === TransactionStatus.Committed}
                    />
                </TabItem>
                <TabItem title="Comments">
                    <CommentTab formFields={formFields} setformFields={setformFields} />
                </TabItem>
                <TabItem title="Alternate SKU">
                    <AlternateSKUTab formFields={formFields} setformFields={setformFields} />
                </TabItem>
                <TabItem title="PO">
                    <POTab formFields={formFields} setformFields={setformFields} />
                </TabItem>
                <TabItem title="IM Kit Detail">
                    <KitDetailTab formFields={formFields} setformFields={setformFields} />
                </TabItem>
                <TabItem title="Other Chgs">
                    <OtherChgsTab formFields={formFields} setformFields={setformFields}/>
                </TabItem>
                <TabItem title="Back Order">
                    <BackOrderTab formFields={formFields} setformFields={setformFields} />
                </TabItem>
            </TabPanel>
            {
                showLocationHistory.visible && (
                    <Popup
                        visible={showLocationHistory.visible}
                        onHiding={() => setShowLocationHistory({ visible: false, RItem: null, RLot: null })}
                        width="90vw"
                        height="90vh"
                        title="Location History"
                        showCloseButton={true}
                    >
                        <LocationHistoryList RItem={showLocationHistory.RItem} RLot={showLocationHistory.RLot} />
                    </Popup>
                )
            }
            {
                showChangeWarehouse.visible && (
                    <ChangeWarehousePopup
                        visible={showChangeWarehouse.visible}
                        onClose={() => setShowChangeWarehouse({ visible: false, currentWarehouseId: null, currentWarehouseName: null })}
                        currentWarehouseId={showChangeWarehouse.currentWarehouseId}
                        currentWarehouseName={showChangeWarehouse.currentWarehouseName}
                        transactionDetailId={formFields.Rowid}
                        itemCode={formFields.ItemCode}
                        lotCode={formFields.LotCode}
                        setLoadPanelVisible ={setLoadPanelVisible}
                        getDetailGridItems={async () => {
                            const grid = dataGrid.current?.instance();
                            if (!grid) return [];
                            const ds = grid.getDataSource();
                            if (!ds) return [];
                            try {
                                const items = await ds.load();
                                return Array.isArray(items) ? items : [];
                            } catch {
                                return [];
                            }
                        }}
                        onSuccess={(newWarehouseId, newWarehouseName) => {
                            setformFields(prev => ({
                                ...prev,
                                WarehouseID: newWarehouseId,
                                WarehouseName: newWarehouseName,
                            }));
                        }}
                    />
                )
            }
            <PMProductionRequirementsModal
                visible={pmRequirementsModal.visible}
                onHiding={() => setPmRequirementsModal({ visible: false, formData: null })}
                formData={pmRequirementsModal.formData}
                onYes={handlePMRequirementsYes}
                accessToken={accessToken}
                currentUser={props.oidc?.user}
                DYNAMICFORMSETTING={props.oidc?.user?.profile?.DYNAMICFORMSETTING}
            />
            {
                showCustomerItemHistory.visible && (
                    <CustomerItemHistoryPopup showPopup={showCustomerItemHistory} setShowPopup={setShowCustomerItemHistory} />
                )
            }
            <SubstituteItemsPopup showPopup={showSubstituteItems} setShowPopup={setShowSubstituteItems} />
            {
                showCostComponents.visible && (
                    <SelectCostComponentsPopup showPopup={showCostComponents} setShowPopup={setShowCostComponents} setLoadPanelVisible={setLoadPanelVisible} />
                )
            }
            <TransactionDetailGridPopup
                showPopup={showTransactionDetailGrid}
                setShowPopup={setShowTransactionDetailGrid}
                onDataChanged={props.onTransactionDetailDataChanged}
                setLoadPanelVisible={setLoadPanelVisible}
            />
            <ImItemStatusPopup showPopup={showImItemStatus} setShowPopup={setShowImItemStatus} />
            {detailPopup}
            <ItemPricesPopup showPopup={showItemPrices} setShowPopup={setShowItemPrices} setLoadPanelVisible={setLoadPanelVisible} />
           { 
            showOpenTransactionForItemLot.visible && (      
            <OpenTransactionsForItemLotPopup
                showPopup={showOpenTransactionForItemLot}
                setShowPopup={setShowOpenTransactionForItemLot}
                setLoadPanelVisible={setLoadPanelVisible}
            />
           )}
            <ResetItemDiscountPopup
                showPopup={showResetItemDiscount}
                setShowPopup={setShowResetItemDiscount}
                setLoadPanelVisible={setLoadPanelVisible}
                profileIncludeDiscountInUnitPrice={props.formFields?.ProfileIncludeDiscountInUnitPrice}
                applyMethod={formFields.ApplyMethod}
                onSuccess={(discount) => {
                    if (dataGrid.current?.instance()) {
                        dataGrid.current.instance().refresh();
                    }
                    if (props.changeTotals) {
                        props.changeTotals(props.formFields.ROWID, props.formFields.SHIPPINGDATE);
                    }
                    setformFields(prev => ({
                        ...prev,
                        Discountpercent: discount,
                    }));
                }}
            />
            <SortDetailRecordsPopup
                visible={showSortDetailRecords}
                onClose={() => setShowSortDetailRecords(false)}
                onApply={handleSortDetailRecords}
            />
            {showSerialNumberReceipt.visible && (
                <SerialNumberReceiptPopup
                    showPopup={showSerialNumberReceipt}
                    setShowPopup={setShowSerialNumberReceipt}
                />
            )}
            {showSerialNumberShipment.visible && (
                <SerialNumberShipmentPopup
                    showPopup={showSerialNumberShipment}
                    setShowPopup={setShowSerialNumberShipment}
                    onSuccess={() => {
                        const grid = dataGrid.current?.instance();
                        if (grid) grid.refresh();
                    }}
                />
            )}
            {showRequisitionDetails.visible && (
                <UpdateRequisitionDetailsPopup
                    showPopup={showRequisitionDetails}
                    setShowPopup={setShowRequisitionDetails}
                    onSuccess={() => {
                        const grid = dataGrid.current?.instance();
                        if (grid) grid.refresh();
                        if (props.changeTotals) {
                            props.changeTotals(props.formFields.ROWID, props.formFields.SHIPPINGDATE);
                        }
                        if (props.onTransactionDetailDataChanged) {
                            props.onTransactionDetailDataChanged();
                        }
                    }}
                />
            )}
            {showSerialImport.visible && (
                <SerialNumberImportPopup
                    showPopup={showSerialImport}
                    setShowPopup={setShowSerialImport}
                    onSuccess={() => {
                        const grid = dataGrid.current?.instance();
                        if (grid) grid.refresh();
                        if (props.onTransactionDetailDataChanged) {
                            props.onTransactionDetailDataChanged();
                        }
                    }}
                />
            )}
            {showItemRange.visible && (
                <Popup
                    visible={true}
                    onHiding={closeItemRange}
                    dragEnabled={true}
                    hideOnOutsideClick={false}
                    showCloseButton={true}
                    showTitle={true}
                    title={MESSAGES.SELECT_ITEMS_RANGE_TITLE}
                    container="#root"
                    width="90vw"
                    height={`${ITEM_RANGE_DIALOG_HEIGHT_VH}vh`}
                >
                    <div style={{ display: "flex", flexDirection: "column", height: "100%", minHeight: 0 }}>
                        <div className="text-muted" style={{ paddingBottom: 8 }}>
                            {MESSAGES.SELECT_ITEMS_RANGE_HINT}
                        </div>
                        <div style={{ flex: "1 1 auto", minHeight: 0, overflow: "hidden" }}>
                            {/* The item-master range report: its fields are the IM Item columns, and its macros
                                are the saved ranges the Find/Save buttons manage. The panes need a definite
                                height - a percentage does not resolve through the tab panel's content wrapper -
                                so they get the dialog's height less its chrome. */}
                            <CommonReport
                                name="GENERATEPOITEM"
                                fullName="GENERATEPOITEM"
                                showMacroButtons={true}
                                embedded={true}
                                paneHeight={`calc(${ITEM_RANGE_DIALOG_HEIGHT_VH}vh - ${ITEM_RANGE_DIALOG_CHROME_PX}px)`}
                                innerRef={itemRangeRef}
                            />
                        </div>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: 10,
                                paddingTop: 12,
                                borderTop: "1px solid #e0e0e0",
                            }}
                        >
                            <Button
                                text={MESSAGES.SELECT_ITEMS_RANGE_APPLY}
                                type="default"
                                onClick={() => openSelectItemsFromRange(true)}
                            />
                            <Button
                                text={MESSAGES.SELECT_ITEMS_RANGE_SKIP}
                                onClick={() => openSelectItemsFromRange(false)}
                            />
                            <Button text="Cancel" onClick={closeItemRange} />
                        </div>
                    </div>
                </Popup>
            )}
            {showSelectItems.visible && (
                <SelectItemsPopup
                    showPopup={showSelectItems}
                    setShowPopup={setShowSelectItems}
                    setLoadPanelVisible={setLoadPanelVisible}
                    onSuccess={() => {
                        const grid = dataGrid.current?.instance();
                        if (grid) grid.refresh();
                        if (props.changeTotals) {
                            props.changeTotals(props.formFields.ROWID, props.formFields.SHIPPINGDATE);
                        }
                        if (props.onTransactionDetailDataChanged) {
                            props.onTransactionDetailDataChanged();
                        }
                    }}
                />
            )}
        </div>
    );
};
function mapStateToProps(state) {
    return {
        oidc: state.oidc,
        ReceiptReducer: state.ReceiptReducer,
    };
}
export default connect(mapStateToProps)(DetailsTab);